import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [demo, setDemo] = useState(false);

  const refresh = async () => {
    if (!localStorage.getItem("ph_token")) {
      setUser(false);
      return;
    }
    for (let i = 0; i < 4; i += 1) {
      try {
        const { data } = await api.get("/auth/me", { timeout: 20000 });
        const map = { direction: "admin", chef_depot: "chauffeur" };
        setUser(map[data.role] ? { ...data, role: map[data.role], real_role: data.role, canEdit: false } : { ...data, canEdit: data.role === "admin" });
        api.get("/demo/status").then((s) => setDemo(s.data.active)).catch(() => {});
        return;
      } catch (e) {
        if (e?.response?.status === 401 || i === 3) {
          if (e?.response?.status === 401) localStorage.removeItem("ph_token");
          setUser(false);
          return;
        }
        await new Promise((r) => setTimeout(r, 1500 * (i + 1)));
      }
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ph_token", data.token);
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ph_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, demo, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
